/**
 * The locale that AI chat answers should prefer.
 *
 * Returns the browser's locale (e.g. "en-GB") so the answer follows the user's
 * preference rather than the language of the analysed videos. This is sent as a
 * fallback; a saved user-level preference on the server takes precedence over it.
 */
export function getPreferredLocale(): string | undefined {
	if (typeof navigator === "undefined") {
		return undefined;
	}
	return navigator.language || undefined;
}
